import { removeZipCodeFromAddress } from './removeZipCodeFromAddress';

/**
 * Собирает строку адреса, при наличии добавляет квартиру в формате ", кв N"
 * и удаляет почтовый индекс.
 *
 * Примеры:
 * - ("Москва, ул Ленина, д 10", "15") -> "Москва, ул Ленина, д 10, кв 15"
 * - ("123456, Москва, ул Ленина, д 10", "15") -> "Москва, ул Ленина, д 10, кв 15"
 */
export const getAddressWithApartmentString = (street?: string, apartment?: string) =>
  removeZipCodeFromAddress(street && `${street}${apartment ? `, кв ${apartment}` : ''}`);
